<template>
    <div>
        <ui-modal ref="editInstanceModal" class="instance-modal" :title="!isEditMode ? 'Stocklisting' : 'Miscellaneous'" @hide="$emit('hide')" dismiss-on="close-button esc">
            <div class="container-fluid" style="padding: 0;">
                <ui-alert v-if="!isEditMode" type="success">The vehicle was added, you can add more information below or skip and add the information later.</ui-alert>

                 <!-- Purchase Details !-->
                <div v-if="figureCloakingIsNotActive && !isPartExchange">
                    <div v-if="isStockVehicle" class="row">
                        <div class="col">
                            <div class="meta-container">
                                <h5>{{ isEditMode ? 'Sale &amp; Return Details' : 'Purchase Details' }}</h5>
                            </div>
                        </div>
                    </div>

                    <div v-if="isStockVehicle" class="row">
                        <div class="col-12">
                            <ui-switch v-model="instance.is_sale_or_return" style="margin-bottom: 1rem;">Is on Sale or Return?</ui-switch>
                        </div>
                    </div>

                    <div class="row" v-if="isSaleOrReturnOrNotEditMode">
                        <div class="col">
                            <contact-picker :label="isSaleOrReturn ? 'Current Owner' : 'Bought From'" v-model="additionalDetail.contact"></contact-picker>
                        </div>
                    </div>

                    <div class="row" style="margin-top: .5rem;" v-if="isSaleOrReturnOrNotEditMode">
                        <div v-if="!isSaleOrReturn" class="col-6">
                            <ui-textbox
                                label="Purchase Invoice Ref #"
                                v-model="additionalDetail.reference"
                            ></ui-textbox>
                        </div>
                        <div v-if="!isSaleOrReturn" class="col-6"></div>
                        <div v-if="!isSaleOrReturn" class="col-6">
                            <ui-datepicker
                                v-model="additionalDetail.tax_at"
                                :custom-formatter="dateFormatter"
                                append-dropdown-to-body
                                :start-of-week="1"
                            >Purchased On</ui-datepicker>
                        </div>
                        <div class="col-6">
                            <ui-textbox
                                :label="isSaleOrReturn ? 'SIV (£\'s)' : 'Purchase Price (£\'s)'"
                                v-model="additionalDetail.unit_cost"
                                help="Excluding any VAT"
                            ></ui-textbox>
                        </div>
                        <div class="col-6">
                            <ui-switch
                                v-model="additionalDetail.vat_rate"
                                :trueValue="VatTariffs.STANDARD"
                                :falseValue="VatTariffs.NONE"
                                :disabled="!!instance.use_commercial_pricing"
                                style="margin-bottom: 0;"
                                label="VAT Qualifier"
                            ></ui-switch>
                        </div>
                        <div class="col-6">
                            <ui-checkbox style="margin-top: 5px;" :disabled="additionalDetail.vat_rate !== VatTariffs.STANDARD" v-model="instance.use_commercial_pricing">
                                <div style="font-size: .9rem;">
                                Commercial Vehicle <ui-icon class="instance-commercial-trigger" style="font-size: 1rem;" icon="info" icon-set="material-icons-outlined"></ui-icon>
                                <ui-tooltip trigger=".instance-commercial-trigger">
                                    Switch on to show the vehicle vehicles pricing excluding VAT if it is a qualifier.
                                </ui-tooltip>
                                </div>
                            </ui-checkbox>
                        </div>
                    </div>

                    <div v-if="isNonStockVehicle" class="row">
                        <div class="col">

                            <!-- Current Owner !-->
                            <div class="row">
                                <div class="col">
                                    <div class="meta-container">
                                        <h5>Owner</h5>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <contact-picker label="Current Owner" v-model="instance.owner"></contact-picker>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <!-- Settlement !-->
                <div style="margin-top: 1rem;" v-if="figureCloakingIsNotActive && !isEditMode && isStockVehicle">
                     <div class="row">
                        <div class="col">
                            <div class="meta-container">
                                <h5>Finance Settlement</h5>
                            </div>
                        </div>
                    </div>

                    <ui-switch
                        v-model="showSettlement"
                        style="margin-bottom: 1rem;">Does this vehicle have outstanding financing?</ui-switch>

                    <finance-settlement-pane
                        ref="settlementPane"
                        v-if="showSettlement"
                        style="margin-bottom: 1rem;"
                    ></finance-settlement-pane>
                </div>

                <!-- Funding !-->
                <div style="margin-top: 1rem;" v-if="figureCloakingIsNotActive && !isEditMode && isStockVehicle && canManageFunding">
                     <div class="row">
                        <div class="col">
                            <div class="meta-container">
                                <h5>Funding</h5>
                            </div>
                        </div>
                    </div>
                    
                    <ui-switch
                        v-model="showFunding"
                        style="margin-bottom: 1rem;">Add vehicle to funding?</ui-switch>

                    <funding-pane
                        ref="fundingPane"
                        v-if="showFunding"
                        :default-stock-listing="storeInstance"
                        hide-stock-listing-selection
                        style="margin-bottom: 1rem;"
                    ></funding-pane>
                </div>

                <div v-if="isStockVehicle || isSold(instance)" class="row">
                    <div class="col">
                        <!-- Location & Delivery Details !-->
                        <div class="row" style="margin-top: 1rem;">
                            <div class="col">
                                <div class="meta-container">
                                    <h5>Location &amp; Delivery Details</h5>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <location-picker 
                                    v-model="instance.location"
                                    label="Sales Location"
                                    :relations-to-load="['salesTeam']"
                                />
                            </div>
                            <div class="col" v-if="!isSold(instance)">
                                <ui-datepicker
                                    :style="{ marginBottom: instance.delivery_on ? '0' : '1rem' }"
                                    v-model="instance.delivery_on"
                                    :custom-formatter="dateFormatter"
                                    append-dropdown-to-body
                                    :start-of-week="1"
                                >Due In / In-stock On</ui-datepicker>
                                <a href="#" v-if="instance.delivery_on" @click="instance.delivery_on = null">Clear</a>
                            </div>
                        </div>

                        <!-- Physical Location Picker !-->
                        <vehicle-instance-modal-physical-location-pane
                            ref="physicalLocationPane"
                            :instance="instance"
                            @input="physicalLocationUpdated"
                        />

                        <!-- V5 Document Reference # !-->
                        <div class="row" style="margin-top: 1.5rem;">
                            <div class="col">
                                <div class="meta-container">
                                    <h5>V5</h5>
                                </div>
                            </div>
                        </div>

                        <div class="row align-items-center">
                            <div class="col-6">
                                <ui-select
                                    label="Status"
                                    :options="v5StatusOptions"
                                    v-model="v5Status"
                                    placeholder="Select status"
                                ></ui-select>
                            </div>
                        </div>


                        <div class="row align-items-center">
                            <div class="col">
                                <ui-masked-text-box v-model="instance.v5_document_reference">
                                    Document Reference Number
                                </ui-masked-text-box>
                            </div>
                        </div>

                        <!-- Key # !-->
                        <div class="row" style="margin-top: 1.5rem;">
                            <div class="col">
                                <div class="meta-container">
                                    <h5>Key Number</h5>
                                </div>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col-6">
                                <ui-textbox 
                                    label="Key #" 
                                    v-model="instance.key_number"
                                ></ui-textbox>
                            </div>
                        </div>

                        <div v-if="isStockVehicle || isSold(instance)" class="row" style="margin-top: 1.5rem;">
                            <div class="col">
                                <div class="meta-container">
                                    <h5>SIV Adjustment</h5>
                                </div>
                            </div>
                        </div>

                        <div v-if="isStockVehicle || isSold(instance)" class="row">
                            <div class="col-6">
                                <ui-textbox
                                    label="Adjustment Amount (£)"
                                    v-model="instance.siv_adjustment"
                                    help="Positive or negative amount to adjust the SIV"
                                ></ui-textbox>
                            </div>
                        </div>

                        <!-- Pricing Details !-->
                        <div v-if="!isEditMode" class="row" style="margin-top: 1.5rem;">
                            <div class="col">
                                <div class="meta-container">
                                    <h5>Pricing &amp; Market</h5>
                                </div>
                            </div>
                        </div>

                        <div v-if="!isEditMode" class="row align-items-center" style=" margin-bottom: -1rem;">
                            <div v-if="!isEditMode" class="col-6">
                                <ui-textbox label="Retail Price (£)" v-model="retailPrice" :help="retailPriceHelp"></ui-textbox>
                            </div>
                            <div class="col-6"></div>
                            <div class="col-6">
                                <ui-select
                                    label="Market"
                                    :options="marketOptions"
                                    v-model="marketProxy"
                                ></ui-select>
                            </div>
                            <div class="col-6">
                                <ui-select
                                    label="Asset Class"
                                    :options="assetClassOptions"
                                    v-model="assetClassProxy"
                                ></ui-select>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div slot="footer" style="width: 100%; text-align: right;">
                <ui-button @click="skip" :disabled="!canSkip" v-if="!isEditMode">Skip</ui-button>
                <ui-button @click="save" color="primary" :loading="isLoading" :disabled="!canSubmit">Save</ui-button>
<!--                <ui-progress-circular :loading="isLoading" v-show="isLoading" style="float:left;"></ui-progress-circular>-->
<!--                <button class="btn btn-secondary" @click="skip" v-if="!isEditMode" :disabled="!canSkip">Skip</button>-->
<!--                <button class="btn btn-primary" @click="save" :disabled="!canSubmit">Save</button>-->
            </div>
        </ui-modal>
    </div>
</template>

<script>
    import { VatTariffs } from '../../../classes/VatService'
    import ContactPicker from '../controls/KeenContactPicker'
    import LocationPicker from '../controls/KeenLocationPicker'
    import Moment from 'moment'
    import { mapState, mapActions } from 'vuex'
    import {
        VehicleInstanceSchema,
        VehicleLifeCycleStatuses,
        VehicleInstanceMarkets,
        VehicleV5StatusList
    } from '../../../classes/Api/Vehicle'
    import { ExpenseResource } from '../../../classes/Api/Expense'
    import PricingVatDisplayHelpers from "./pricing/PricingVatDisplayHelpers";
    import DealerKit from "../../../api";
    import {figureCloakingIsNotActive, listOptionsFromEnum, log, reportApiError} from "../../../utils";
    import FundingPane from "../../finance/funding/FundingPane";
    import {FinanceSettlementPane} from "../../finance";
    import VehicleInstanceModalPhysicalLocationPane from "./VehicleInstanceModalPhysicalLocationPane.vue";
    import {StockListingAssetClass, StockListingMarket, V5Status} from "../../../../../api-clients/ts";
    import UiMaskedTextBox from "../../../../ts/Elements/UiMaskedTextBox.vue";
    import {isSold} from "../../finance/funding/helpers";
    import {isNotSold} from "../../vehicles/show/helpers";

    export default {
        components: {
            UiMaskedTextBox,
            VehicleInstanceModalPhysicalLocationPane,
            FinanceSettlementPane, FundingPane, ContactPicker, LocationPicker },
        mixins: [PricingVatDisplayHelpers],
        props: {
            isEditMode: {
                type: Boolean,
                default() {
                    return true;
                }
            }
        },
        created() {
            this.$on('saved', () => {
                this.$refs['editInstanceModal'].close();
            });
        },
        data() {
            return {
                isLoading: false,
                VatTariffs,
                VehicleLifeCycleStatuses,
                VehicleInstanceMarkets,
                instance: new VehicleInstanceSchema({
                    location: window.marque.ui.location,
                    delivery_on: new Date(),
                    is_trade_only: { label: 'Retail', value: false, },
                }),
                additionalDetail: {
                    contact: null,
                    unit_cost: null,
                    vat_rate: VatTariffs.NONE,
                    tax_at: new Date(),
                    reference: null,
                },
                showFunding: false,
                showSettlement: false,
            }
        },
        computed: {
            v5Status: {
                get() {
                    const option = this.v5StatusOptions.find(
                        item => item.value === this.instance.v5_status
                    )

                    return option ?? ''
                },
                set(option) {
                    this.instance.v5_status = option.value
                }
            },
            v5StatusOptions() {
                return listOptionsFromEnum(V5Status)
            },
            marketOptions() {
                return listOptionsFromEnum(StockListingMarket)
            },
            marketProxy: {
                get() {
                    return this.marketOptions.find(item => {
                        return item.value === this.instance.market
                    }) ?? this.marketOptions.find(item => {
                        return item.value === StockListingMarket.None
                    })
                },
                set(item) {
                    this.instance.market = item.value
                }
            },
            assetClassOptions() {
                return listOptionsFromEnum(StockListingAssetClass)
            },
            assetClassProxy: {
                get() {
                    return this.assetClassOptions.find(item => {
                        return item.value === this.instance.asset_class
                    }) ?? this.assetClassOptions.find(item => {
                        return item.value === StockListingAssetClass.Stock
                    })
                },
                set(item) {
                    this.instance.asset_class = item.value
                }
            },
            isPartExchange() {
                return !!this.instance.is_part_exchange
            },
            canManageFunding() {
                return window.marque.ui.authorisations['manage_funding.accounts']
            },
            figureCloakingIsNotActive,
            ...mapState({ 'storeInstance': state => state.instance.instance }),
            isNonStockVehicle() {
                return this.instance.market === VehicleInstanceMarkets.NONE && this.instance.asset_class === StockListingAssetClass.None && this.instance.owner ||
                    this.instance.life_cycle_status >= VehicleLifeCycleStatuses.SOLD;
            },
            isStockVehicle() {
                return (this.instance.market !== VehicleInstanceMarkets.NONE || this.instance.asset_class !== StockListingAssetClass.None) &&
                    this.instance.life_cycle_status < VehicleLifeCycleStatuses.SOLD
            },
            isSaleOrReturn() {
                return this.isStockVehicle && this.instance.is_sale_or_return
            },
            isSaleOrReturnOrNotEditMode() {
                return !this.isEditMode || this.isSaleOrReturn
            },
            retailPrice: {
                get() {
                    let price = this.instance.retail_price

                    if (!this.vatInclusivePricing && this.additionalDetail.vat_rate === VatTariffs.STANDARD) {
                        price = this.getVatService().unvatify(price)
                    }

                    return price
                },
                set(price) {
                    if (!this.vatInclusivePricing && this.additionalDetail.vat_rate === VatTariffs.STANDARD) {
                        price = this.getVatService().vatify(price)
                    }

                    this.instance.retail_price = price
                }
            },
            retailPriceHelp() {
                if (!this.vatInclusivePricing) {
                    return 'Excluding VAT'
                }

                return 'Including any VAT'
            },
            isPurchaseDetailValid() {
                return this.additionalDetail.tax_at && this.instance.location.sales_team &&
                    this.additionalDetail.contact && this.additionalDetail.contact.id &&
                    this.additionalDetail.unit_cost && this.additionalDetail.vat_rate !== ''
            },
            isPurchaseDetailPartFilled() {
                return (this.instance.location.sales_team &&
                    this.additionalDetail.contact && this.additionalDetail.contact.id &&
                    this.additionalDetail.unit_cost && this.additionalDetail.vat_rate !== '') &&
                    !this.instance.is_sale_or_return
            },
            isSaleOrReturnDetailPartFilled()
            {
                return (this.additionalDetail.contact && this.additionalDetail.contact.id ||
                    this.additionalDetail.unit_cost) && this.instance.is_sale_or_return
            },
            isSaleOrReturnDetailValid()
            {
                return (this.additionalDetail.contact && this.additionalDetail.contact.id &&
                    this.additionalDetail.unit_cost) && this.instance.is_sale_or_return
            }
        },
        methods: {
            isNotSold,
            isSold,
            ...mapActions({ 'update': 'instance/update' }),
            open(additionalDetail = {}) {
                this.isLoading = false;

                if (this.isEditMode) {
                    this.v5DocumentReferenceVisible = false
                }

                this.instance = Object.assign({}, this.instance, this.storeInstance, {
                   delivery_on: this.storeInstance.delivery_on ? (new Moment(this.storeInstance.delivery_on)).toDate() : null,
                   market: this.storeInstance.market,
                   asset_class: this.storeInstance.asset_class,
                   owner: this.storeInstance.owner ? this.storeInstance.owner : {},
                   location: this.storeInstance.location ? this.storeInstance.location : {},
                   retail_price: this.storeInstance.retail_price ? this.storeInstance.retail_price : '',
                   siv_adjustment: this.storeInstance.siv_adjustment ? this.storeInstance.siv_adjustment : null,
                });

                const vat_rate = this.instance.is_vat_qualifier ? VatTariffs.STANDARD : VatTariffs.NONE

                this.additionalDetail = {
                    contact: this.instance.is_sale_or_return ? this.instance.owner : null,
                    unit_cost: this.instance.is_sale_or_return ? this.getVatService().unvatify(this.instance.siv_base, vat_rate) : null,
                    vat_rate,
                    tax_at: new Date(),
                    reference: '',
                    ...additionalDetail
                };

                this.$nextTick(() => {
                    this.$refs['physicalLocationPane'].reset()
                })

                this.$refs['editInstanceModal'].open();
            },
            close() {
                this.$refs['editInstanceModal'].close();
            },
            dateFormatter(date) {
                return (new Moment(date)).format('DD/MM/YYYY')
            },
            canSubmit() {
                return !this.isLoading;
            },
            canSkip() {
                return !this.isLoading;
            },
            skip() {
                this.$refs['editInstanceModal'].close();

                this.$emit('skipped');
            },
            physicalLocationUpdated(data) {
                this.instance = {...this.instance, ...data}
            },
            save() {
                this.isLoading = true;

                this.$emit('save');

                let data = Object.assign({}, this.instance, {
                    owner_id: this.instance.owner.id,
                    location_id: this.instance.location.id,
                    market: this.instance.market,
                    asset_class: this.instance.asset_class,
                    use_commercial_pricing: this.instance.use_commercial_pricing,
                    siv_adjustment: this.instance.siv_adjustment,
                    delivery_on: this.instance.delivery_on ? (new Moment(this.instance.delivery_on)).startOf('day') : null,
                });

                // Validate the funding pane.
                if (!this.isEditMode && this.showFunding) {
                    if (!this.$refs.fundingPane.validate()) {
                        alert('You have specified the vehicle is on funding, please add the amount funded.')
                        this.isLoading = false
                        return
                    }
                }

                // Validate the settlement pane.
                if (!this.isEditMode && this.showSettlement) {
                    if (!this.$refs.settlementPane.settlementValid) {
                        alert('You have specified the vehicle has a settlement, please add the settlement amount.')
                        this.isLoading = false
                        return
                    }
                }

                if (!this.isEditMode && this.isPurchaseDetailPartFilled && !this.isPurchaseDetailValid) {
                    alert('Please fill in all of the purchase & location details before continuing.')
                    this.isLoading = false
                    return
                }

                if (this.isSaleOrReturn && !this.isSaleOrReturnDetailValid) {
                    alert('Please fill in all of the sale or return details before continuing.')
                    this.isLoading = false
                    return
                }

                if (this.showFunding) {
                    this.$refs.fundingPane.sendForFunding().then(() => {
                        this.storeSettlementDetails(data)
                    })
                } else {
                    this.storeSettlementDetails(data)
                }

            },
            startSavingAcquisitionDetails(data) {
              // Add the purchase information if specified.
                if (this.instance.is_sale_or_return && this.isSaleOrReturnDetailValid) {
                    DealerKit.stockList.setSaleOrReturn(this.instance.id, {
                        siv: this.getVatService().vatify(this.additionalDetail.unit_cost, this.additionalDetail.vat_rate),
                        owner_id: this.additionalDetail.contact.id,
                        is_vat_qualifier: this.additionalDetail.vat_rate === VatTariffs.STANDARD
                    }).then(() => {
                        this.finishUpdatingInstance(data)
                    }).catch(r => {
                        handleApiError(r)
                        this.isLoading = false
                    })
                } else if (!this.isEditMode && this.isPurchaseDetailValid) {
                    this.storePurchaseDetails(data);
                } else {
                    if (this.storeInstance.is_sale_or_return && !this.instance.is_sale_or_return) {
                        DealerKit.stockList.removeSaleOrReturn(this.instance.id).then(() => {
                            this.finishUpdatingInstance(data);
                        })
                    } else {
                        this.finishUpdatingInstance(data);
                    }
                }
            },
            storePurchaseDetails(data) {
                ExpenseResource.store({
                    tax_at: this.additionalDetail.tax_at,
                    contact_id: this.additionalDetail.contact.id,
                    team_id: this.instance.location.sales_team.id,
                    reference: this.additionalDetail.reference,
                    items: [
                        {
                            instance_id: this.instance.id,
                            quantity: 1,
                            unit_cost: this.additionalDetail.unit_cost,
                            expense_category_id: window.marque.ui.defaultVehicleExpenseCategory.id,
                            vat_rate: this.additionalDetail.vat_rate,
                            description: this.instance.search_description,
                        }
                    ]
                }).then(response => {
                    this.finishUpdatingInstance(data);
                }, handleApiError);
            },
            storeSettlementDetails(data) {
                if (this.showSettlement) {
                    this.$refs.settlementPane.setStockListing(this.instance.id)
                    this.$refs.settlementPane.save().then(() => {
                        this.startSavingAcquisitionDetails(data)
                    })
                } else {
                    this.startSavingAcquisitionDetails(data)
                }
            },
            finishUpdatingInstance(data) {
                this.update(data).then(instance => {
                    this.$emit('saved', instance);
                }).catch(() => { this.isLoading = false });
            }
        }
    }
</script>